<template>
  <div class="sp_addDevice">
    <heade-title :title="title"></heade-title>
    <div class="sp_content">
      <el-row style="background: #F1F6FB; padding:15px 0;">
        <el-col :span="24">
          <el-steps :active="activeStep"
                    align-center
                    finish-status="success">
            <el-step title="Choose Add Device"></el-step>
            <el-step title="Submit Device SN or ID"></el-step>
            <el-step title="Check Device Information"></el-step>
          </el-steps>
        </el-col>
      </el-row>

      <el-row class="sp_deviceStep1"
              v-if="activeStep==1">
        <el-col :span="24">
          <div class="sp_deviceRadio"
               v-for="val in radioList"
               :key="val.id">
            <span>{{val.label}}</span>
            <i class="el-icon-check"></i>
          </div>
        </el-col>
      </el-row>

      <el-form :model="addDeviceFrom"
               ref="addDeviceFrom"
               :rules="addDeviceRules"
               class="addDeviceFrom"
               v-if="activeStep==2">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="Order No."
                          prop="orderNo">
              <el-input size="medium"
                        type="text"
                        v-model="addDeviceFrom.orderNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Device ID or SN."
                          prop="deviceId">
              <el-input size="medium"
                        type="text"
                        v-model="addDeviceFrom.deviceId"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="margin-top:50px;">
          <el-col>
            <el-form-item style="text-align:center;">
              <el-button size="medium"
                         plain>Back</el-button>
              <el-button size="medium"
                         type="primary">Next</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import headeTitle from '../../components/headeTitle.vue'
export default {
  components: { headeTitle },
  name: "addDevice",
  data () {
    return {
      activeStep: 1,
      title: 'Add Asset',
      addDeviceFrom: {
        orderNo: "",
        deviceId: '',
      },
      radioList: [
        { id: 1, label: 'Add a device' },
        { id: 2, label: 'Add multiple devices' },
      ],
      addDeviceRules: {
        orderNo: [
          { required: true, message: "sss", trigger: "blur", }
        ],
        deviceId: [
          { required: true, message: "sss", trigger: "blur", }
        ],
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sp_addDevice {
  width: 100%;
  height: 100%;
  .sp_content {
    width: 100%;
    background: #fff;
    padding: 16px;
    height: calc(100% - 53px);
    .sp_deviceStep1 {
      padding: 0 560px;
      margin-top: 56px;
      .sp_deviceRadio {
        width: 100%;
        padding: 20px;
        border-radius: 4px;
        border: 1px solid #ddd;
        margin-bottom: 20px;
        cursor: pointer;
        // background:rgba($color: #007AFF, $alpha: .1);
      }
    }
    .addDeviceFrom {
      padding: 0 200px;
      margin-top: 60px;
    }
    // /deep/.el-step__title {
    //   color: black !important;
    //   font-weight: 600 !important;
    // }
    /deep/.el-step__head.is-success {
      color: #007aff;
      border-color: #007aff;
      .el-step__line {
        background: #007aff;
      }
    }
    /deep/.el-step__head.is-process {
      color: #fff;
      border-color: #007aff;
      .el-step__icon.is-text {
        background: #007aff;
      }
    }
  }
}
</style>